// TODO Vorbert -> dodać do scss-owych zmiennych -> defaultDesktopFontSize
export const pxToRem = (pxValue = 0) => `${pxValue / 18}rem`;
export const parseToPx = (value = '') =>
    value.endsWith('px') ? value : `${value}px`;

// TODO Vorbert -> zrobić customową funkcję na stylowania styled-components
